export default __webpack_public_path__ + "static/media/ember.c1e57f88.svg";